import React, { useState } from "react"
import { Button, Form, Container, Row, Col, Card } from "react-bootstrap"
import { Oval } from "react-loader-spinner"
import { useAuth } from "../components/AuthContext" // Your AuthContext hook
import { useNavigate } from "react-router-dom"

const Login = () => {
  const navigate = useNavigate()
  const { login, error } = useAuth() // Use error from AuthProvider

  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [localError, setLocalError] = useState(null) // Local error state
  const [loading, setLoading] = useState(false)

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    setLocalError(null) // Clear local errors before login

    // Validate inputs before calling login
    if (!username.trim() || !password.trim()) {
      setLocalError("Proszę wprowadzić email i hasło")
      setLoading(false)
      return
    }

    try {
      await login(username.trim(), password) // Call login from context
    } catch (err) {
      setLocalError(err.message) // Fallback to local error handling
    } finally {
      setLoading(false)
    }
  }

  const resetErrors = () => {
    setLocalError(null)
  }

  return (
    <Container className="h-screen flex justify-center items-center">
      <Row className="w-full justify-center">
        <Col>
          <Card className="shadow-lg rounded-lg w-full">
            <Card.Body>
              <h2 className="text-center text-xl mb-6">Logowanie admina</h2>

              <Form onSubmit={handleLogin}>
                <Form.Group controlId="username mb-4">
                  <Form.Label className="text-black">Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Wprowadź email"
                    value={username}
                    onChange={(e) => {
                      setUsername(e.target.value)
                      resetErrors() // Reset errors on input change
                    }}
                    className="border-2 border-gray-300 rounded-lg"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-2" controlId="password">
                  <Form.Label className="text-black">Hasło</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Wprowadź hasło"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value)
                      resetErrors() // Reset errors on input change
                    }}
                    className="border-2 border-gray-300 rounded-lg"
                    required
                  />
                </Form.Group>

                <div
                  onClick={() => navigate("/forgotpassword")}
                  className="w-full flex items-end text-end mb-4"
                >
                  <div className="font-bold text-[#32A5FF] text-sm">
                    Przypomnij hasło?
                  </div>
                </div>

                {/* Display Error Message */}
                {(error || localError) && (
                  <p
                    className="text-center mb-4 font-bold"
                    style={{ color: "red", fontWeight: "bold" }}
                  >
                    {error || localError}
                  </p>
                )}

                <div
                  onClick={() => navigate("/adminsignup")}
                  style={{ display: "flex", flexDirection: "row" }}
                >
                  Nie masz konta?&nbsp;
                  <div style={{ color: "blue" }}>Zarejestruj się.</div>
                </div>

                <div className="w-full flex items-center text-center mt-4">
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-lg"
                  >
                    {loading ? (
                      <div>
                        <Oval
                          visible={true}
                          height="20"
                          width="20"
                          color="#fff"
                          secondaryColor="#f5f5f5"
                          ariaLabel="oval-loading"
                        />
                      </div>
                    ) : (
                      <div>Zaloguj się</div>
                    )}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default Login
